import { Brand, createBranded } from '@deltasierra/type-utilities';

export type EmailTemplateDocumentAssetId = Brand<string, 'EmailTemplateDocumentAssetId'>;
export const EmailTemplateDocumentAssetId = createBranded<EmailTemplateDocumentAssetId>();
